// Shared MSG91 SendOTP widget helpers (client-side widget creds only — authkey stays on server).

export const MSG91_WIDGET_ID = process.env.REACT_APP_MSG91_WIDGET_ID;
export const MSG91_TOKEN_AUTH = process.env.REACT_APP_MSG91_TOKEN_AUTH;

export function loadMsg91() {
  return new Promise((resolve, reject) => {
    if (window.initSendOTP) return resolve();
    const s = document.createElement("script");
    s.src = "https://verify.msg91.com/otp-provider.js";
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("MSG91 widget load nahi hua"));
    document.head.appendChild(s);
  });
}

// Widget versions return the access token under different keys — tolerate all.
export const extractOtpToken = (d) =>
  (typeof d === "string" && d) || d?.message || d?.accessToken || d?.["access-token"] ||
  d?.token || d?.data?.accessToken || d?.data?.["access-token"] || d?.data?.message || null;

// Human-readable reason from a MSG91 widget failure payload (for toasts / debugging).
export const otpErr = (e) => {
  try {
    if (!e) return "OTP error";
    if (typeof e === "string") return e;
    return e.message || e.msg || e.type || JSON.stringify(e);
  } catch { return "OTP error"; }
};

export async function initOtpWidget({ onToken, onFailure }) {
  await loadMsg91();
  window.initSendOTP({
    widgetId: MSG91_WIDGET_ID,
    tokenAuth: MSG91_TOKEN_AUTH,
    exposeMethods: true,
    success: (d) => { const t = extractOtpToken(d); if (t) onToken(t); },
    failure: (e) => { if (onFailure) onFailure(e); },
  });
}
